var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-icon",class:{ disabled: _vm.disabled }},[_c('span',[_vm._v(_vm._s(_vm.getInitials(_vm.firstName, _vm.lastName)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }